import { render, staticRenderFns } from "./ChangePayCardSmallButtons.vue?vue&type=template&id=0a94464d&scoped=true"
import script from "./ChangePayCardSmallButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangePayCardSmallButtons.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ChangePayCardSmallButtons.vue?vue&type=style&index=0&id=0a94464d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a94464d",
  null
  
)

export default component.exports